// src/router/contrato.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['triveni_contratos']

const contratoBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Contratos',
    to: 'Contratos'
  }
]

export default [
  {
    path: '/contratos',
    name: 'Contratos',
    component: () => import('@/views/Contrato/ListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Contratos',
      breadcrumb: contratoBreadCrumb
    }
  },
  {
    path: '/contratos/novo',
    name: 'ContratoNovo',
    component: () => import('@/views/Contrato/Page.vue'),
    meta: {
      roles: ROLES,
      title: 'Novo Contrato',
      breadcrumb: [
        ...contratoBreadCrumb,
        {
          label: 'Novo Contrato',
          to: 'ContratoNovo'
        }
      ]
    }
  },
  {
    path: '/contratos/:id/edit',
    name: 'ContratoEdit',
    component: () => import('@/views/Contrato/Page.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes do Contrato',
      breadcrumb: [
        ...contratoBreadCrumb,
        {
          label: 'Detalhes do Contrato',
          to: 'ContratoEdit'
        }
      ]
    }
  }
]
